/**
 * Agent Execution Panel component.
 * Displays the execution progress of agent actions.
 */

import React from 'react';
import type { AgentActionResult } from '@excel-ai-studio/shared';
import { Card, CardHeader, CardPreview, Body1, Caption1 } from '@fluentui/react-components';
import { CheckmarkCircleRegular, ErrorCircleRegular, TimerRegular } from '@fluentui/react-icons';

interface AgentExecutionPanelProps {
  execution: readonly AgentActionResult[];
}

export const AgentExecutionPanel: React.FC<AgentExecutionPanelProps> = ({ execution }) => {
  const successCount = execution.filter((r) => r.success).length;
  const totalCount = execution.length;

  return (
    <div className="agent-execution-panel">
      <Card>
        <CardHeader
          header={<Body1 style={{ fontWeight: 600 }}>Exécution</Body1>}
          description={
            <Caption1>
              {successCount}/{totalCount} étapes réussies
            </Caption1>
          }
        />
        <CardPreview>
          <div className="execution-content">
            <ul className="execution-list">
              {execution.map((result) => (
                <li key={result.stepId} className={`execution-item ${result.success ? 'success' : 'error'}`}>
                  <div className="execution-icon">
                    {result.success ? (
                      <CheckmarkCircleRegular style={{ color: '#107C10' }} />
                    ) : (
                      <ErrorCircleRegular style={{ color: '#E81123' }} />
                    )}
                  </div>
                  <div className="execution-details">
                    <Caption1 style={{ fontWeight: 600 }}>{result.action}</Caption1>
                    {result.error && <Caption1 style={{ color: '#E81123' }}>{result.error}</Caption1>}
                    <Caption1 style={{ color: '#666' }}>
                      <TimerRegular style={{ fontSize: '12px' }} /> {result.duration}ms
                    </Caption1>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </CardPreview>
      </Card>
    </div>
  );
};
